import { useAppSelector } from "@app/store";
import {
  Select,
  SelectContent,
  SelectItem,
} from "@assets/components/ui/select";
import { BaseDevice } from "@components/devices/device";
import { SelectOption } from "@components/select";
import { useDevicesDispatch } from "@features/device";
import { Trigger } from "@radix-ui/react-select";
import { useEffect, useState } from "react";
import { Control, Controller } from "react-hook-form";

type Props = {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
};

export const DevicesSelect = ({ control, name }: Props) => {
  const { getDevicesSmall } = useDevicesDispatch();
  const devicesSmall = useAppSelector((state) => state.device.devicesSmall);

  const [deviceOptions, setDeviceOptions] = useState<SelectOption[]>([]);

  useEffect(() => {
    getDevicesSmall();
  }, [getDevicesSmall]);

  useEffect(() => {
    const options = devicesSmall.map((deviceSmall) => ({
      text: deviceSmall.name,
      value: deviceSmall.id,
    }));
    setDeviceOptions(options);
  }, [devicesSmall]);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, formState: { errors } }) => {
        const errorField = errors[name];
        const error = errorField
          ? (errorField.message as string | undefined)
          : undefined;

        const selectedDevice = devicesSmall.find(
          (device) => device.id === value
        );

        const deviceName = selectedDevice?.name || "Выберите устройство";

        return (
          <div className="relative">
            <Select onValueChange={onChange} value={value || ""}>
              <Trigger className="w-full">
                <BaseDevice
                  onClick={() => {}}
                  name={deviceName}
                  status={"select"}
                />
              </Trigger>

              <SelectContent className={`z-[1000]`}>
                {deviceOptions.map((item) => (
                  <SelectItem value={item.value} key={item.value}>
                    {item.text}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {error && (
              <span className="absolute bottom-[-3px] left-0 text-[10px] font-normal text-red-500">
                {error}
              </span>
            )}
          </div>
        );
      }}
    />
  );
};
